import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const Solutions = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
   <section className="lg:py-28 lg:px-12 px-5 py-12 bg-bgDefault text-white">
      <div className="container mx-auto max-w-screen-xl">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            What We Did & How We Did It
          </h2>

          {/* <h3 className="text-2xl lg:text-3xl font-semibold text-[#00E599] mb-4">What We Did & How We Did It</h3> */}

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            We designed and implemented a cutting-edge cloud-native banking platform using microservices architecture
            with Java and Spring Boot. The solution leverages Event-Driven Design (EDD) principles with Amazon MQ for
            asynchronous message processing, hybrid database strategy combining SQL and NoSQL for optimal performance,
            and complete containerization using Docker with Kubernetes orchestration on Amazon EKS. We implemented
            Horizontal Pod Autoscaling (HPA) for intelligent resource management and OAuth 2.0 for enterprise-grade
            security, all deployed across AWS infrastructure including Amazon ECR for container registry and Amazon S3
            for object storage.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Core Features Delivered:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6 list-disc pl-5 space-y-2">
            <li data-aos="zoom-in" data-aos-delay="250"><strong>Microservices Architecture:</strong> Decomposed monolith into 50+ independent microservices enabling parallel development, deployment, and scaling</li>
            <li data-aos="zoom-in" data-aos-delay="300"><strong>Event-Driven Design:</strong> Implemented asynchronous communication using Amazon MQ and Kafka for real-time transaction processing and notifications</li>
            <li data-aos="zoom-in" data-aos-delay="350"><strong>Cloud-Native Deployment:</strong> Full AWS infrastructure leveraging EKS, ECR, S3, RDS, and ElastiCache for global scalability and reliability</li>
            <li data-aos="zoom-in" data-aos-delay="400"><strong>Auto-Scaling Infrastructure:</strong> Kubernetes HPA automatically adjusts resources based on CPU/memory utilization and custom metrics</li>
            <li data-aos="zoom-in" data-aos-delay="450"><strong>Hybrid Database Strategy:</strong> PostgreSQL for transactional data, MongoDB for customer profiles, Redis for caching and session management</li>
            <li data-aos="zoom-in" data-aos-delay="500"><strong>OAuth 2.0 Security:</strong> Comprehensive authentication and authorization with JWT tokens, role-based access control, and API gateway security</li>
            <li data-aos="zoom-in" data-aos-delay="550"><strong>Third-Party Integrations:</strong> RESTful APIs and message queue integrations with core banking systems, payment gateways, and financial data providers</li>
            <li data-aos="zoom-in" data-aos-delay="600"><strong>Personalization Engine:</strong> Machine learning-powered recommendation system analyzing customer behavior for tailored banking experiences</li>
          </ul>

          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8 mt-8"
            data-aos="fade-down"
            data-aos-delay="650"
          >
            Results Achieved
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="700">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">2M</h5>
              <p className="text-[#9E9E9E]">Peak concurrent users handled without disruptions</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="750">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">500K+</h5>
              <p className="text-[#9E9E9E]">Daily active users served consistently</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="800">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">&lt;3s</h5>
              <p className="text-[#9E9E9E]">API response time SLA maintained across all services</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="850">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">150+</h5>
              <p className="text-[#9E9E9E]">Banks worldwide modernized with the platform</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="900">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">99.9%</h5>
              <p className="text-[#9E9E9E]">Platform uptime with auto-scaling and failover</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="950">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">75%</h5>
              <p className="text-[#9E9E9E]">Faster feature deployment with microservices</p>
            </div>
          </div>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="1000"
          >
            The cloud-native platform revolutionized digital banking for millions of users across 150+ financial
            institutions worldwide. Microservices architecture enabled rapid innovation, event-driven design ensured
            real-time responsiveness, and intelligent auto-scaling delivered consistent performance during peak loads.
            The solution established new industry benchmarks for modern banking infrastructure, positioning the client
            as the leading fintech innovator in the APAC region and beyond.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Solutions
